import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      width={1115.124}
      height={937.78}
      viewBox="0 0 1115.124 937.78"
      {...props}
    >
      <g transform="translate(-164.876)">
        <path
          data-name="Path 4"
          d="M180.55 520.115h224.787l111.725 38.336 126.9 48.726 167.507-141.132h329.364"
          fill="none"
          stroke="#3f3d56"
          strokeMiterlimit={10}
          strokeWidth={2}
        />
        <path
          data-name="Path 1"
          d="M1274.748 584.184c17.969 133.732-6.5 267.61-130.956 319.742s-267.61-6.5-319.742-130.956 70.87-198.925 130.956-319.742c122.018-245.345 263.939-284.347 319.742 130.956z"
          fill="#f2f2f2"
        />
        <ellipse
          data-name="Ellipse 2"
          cx={194.997}
          cy={26.528}
          rx={194.997}
          ry={26.528}
          transform="translate(855.693 884.724)"
          fill="#3f3d56"
        />
        <path
          data-name="Rectangle 1"
          fill="#2f2e41"
          d="M930.454 870.27l-7.335-26.534 47.54-13.142 7.335 26.534z"
        />
        <ellipse
          data-name="Ellipse 3"
          cx={8.603}
          cy={22.941}
          rx={8.603}
          ry={22.941}
          transform="rotate(-15.453 3522.843 -2921.904)"
          fill="#2f2e41"
        />
        <ellipse
          data-name="Ellipse 4"
          cx={45.308}
          cy={14.224}
          rx={45.308}
          ry={14.224}
          transform="rotate(-82.281 973.635 -197.833)"
          fill="#2f2e41"
        />
        <circle
          data-name="Ellipse 5"
          cx={90.616}
          cy={90.616}
          r={90.616}
          transform="translate(959.598 744.774)"
          fill="#2f2e41"
        />
        <path
          data-name="Rectangle 2"
          fill="#2f2e41"
          d="M930.454 854.211l-7.335-26.534 47.54-13.142 7.335 26.534z"
        />
        <ellipse
          data-name="Ellipse 6"
          cx={8.603}
          cy={22.941}
          rx={8.603}
          ry={22.941}
          transform="rotate(-15.453 3463.661 -2929.933)"
          fill="#2f2e41"
        />
        <circle
          data-name="Ellipse 7"
          cx={30.97}
          cy={30.97}
          r={30.97}
          transform="translate(1043.039 752.509)"
          fill="#fff"
        />
        <circle
          data-name="Ellipse 8"
          cx={10.323}
          cy={10.323}
          r={10.323}
          transform="translate(1073.589 759.475)"
          fill="#3f3d56"
        />
        <path
          data-name="Path 2"
          d="M1154.859 897.664c33.533-1.678 59.216-33.044 57.363-70.057s-30.538-65.658-64.071-63.979-38.8 28-36.943 65.015 10.118 70.696 43.651 69.021z"
          fill="#4d5fe8"
        />
        <path
          data-name="Path 3"
          d="M1013.178 797.05a20.647 20.647 0 11-3.331-41.159c11.366-.92 14.465 8.1 15.385 19.469s-.687 20.77-12.054 21.69z"
          fill="#fff"
        />
        <circle
          data-name="Ellipse 9"
          cx={15.698}
          cy={15.698}
          r={15.698}
          transform="translate(164.876 505.477)"
          fill="#4d5fe8"
        />
        <circle
          data-name="Ellipse 10"
          cx={15.698}
          cy={15.698}
          r={15.698}
          transform="translate(390.388 505.418)"
          fill="#4d5fe8"
        />
        <path
          data-name="Path 11"
          d="M639.786 591.79a15.7 15.7 0 11-15.7 15.7 15.7 15.7 0 0115.7-15.7z"
          fill="#4d5fe8"
        />
        <circle
          data-name="Ellipse 13"
          cx={15.698}
          cy={15.698}
          r={15.698}
          transform="translate(795.504 450.395)"
          fill="#4d5fe8"
        />
        <path
          data-name="Rectangle 7"
          fill="#4d5fe8"
          d="M958.324 647.746h144.675v73.596H958.324z"
        />
        <path
          data-name="Rectangle 8"
          fill="none"
          stroke="#3f3d56"
          strokeMiterlimit={10}
          strokeWidth={2}
          d="M947.002 659.697h144.675v73.596H947.002z"
        />
        <path
          data-name="Rectangle 9"
          fill="#ff6565"
          d="M563.924 398.261h41.294v41.294h-41.294z"
        />
        <path
          data-name="Rectangle 10"
          fill="none"
          stroke="#3f3d56"
          strokeMiterlimit={10}
          strokeWidth={2}
          d="M553.6 384.497h41.294v41.294H553.6z"
        />
        <path
          data-name="Line 2"
          fill="none"
          stroke="#3f3d56"
          strokeMiterlimit={10}
          strokeWidth={2}
          d="M834.386 137.557l170.114 86.868"
        />
        <circle
          data-name="Ellipse 34"
          cx={77.999}
          cy={77.999}
          r={77.999}
          transform="translate(690.064)"
          fill="#ff6565"
        />
        <ellipse
          data-name="Ellipse 35"
          cx={45.308}
          cy={14.224}
          rx={45.308}
          ry={14.224}
          transform="rotate(-82.281 968.953 -167.601)"
          fill="#2f2e41"
        />
        <circle
          data-name="Ellipse 37"
          cx={8.198}
          cy={8.198}
          r={8.198}
          transform="translate(942.876 458.083)"
          fill="#4d5fe8"
        />
        <circle
          data-name="Ellipse 38"
          cx={15.698}
          cy={15.698}
          r={15.698}
          transform="translate(796.186 884.827)"
          fill="#ff6565"
        />
        <circle
          data-name="Ellipse 39"
          cx={7.496}
          cy={7.496}
          r={7.496}
          transform="translate(827.23 771.634)"
          fill="#ff6565"
        />
        <path
          data-name="Line 3"
          fill="#3f3d56"
          stroke="#3f3d56"
          strokeMiterlimit={10}
          strokeWidth={2}
          d="M871.453 903.553V818.2"
        />
        <circle
          data-name="Ellipse 40"
          cx={12.07}
          cy={12.07}
          r={12.07}
          transform="translate(859.383 806.13)"
          fill="#3f3d56"
        />
        <path
          data-name="Path 10"
          d="M871.453 870.805s-1.724-37.086-37.073-32.775"
          fill="#3f3d56"
        />
        <path
          data-name="Path 16"
          d="M1109.581 259.713c-7.088 1.005-12.333 4.644-11.716 8.133s6.863 5.49 13.95 4.49 12.333-4.647 11.716-8.134-6.863-5.494-13.95-4.489z"
          fill="#4d5fe8"
        />
        <path
          data-name="Path 12"
          d="M1070.493 254.537c1.708 2.775 8.557 4.047 15.3 2.838s10.815-4.438 9.107-7.215-8.557-4.045-15.3-2.836-10.814 4.438-9.107 7.213zm12.684-1.044c2.127-.382 4.091-.3 4.385.176s-1.188 1.174-3.319 1.555-4.091.3-4.385-.175 1.192-1.175 3.319-1.555z"
          fill="#2f2e41"
        />
        <path
          data-name="Path 13"
          d="M1180.801 218.001a82.237 82.237 0 00-17.924-25.643 113.48 113.48 0 00-32.478-22.41c-2.167-1-4.375-1.917-6.961-3.048a20.918 20.918 0 001.91-1.548c2.314-2.416 2.2-6.222-.269-7.854a6.35 6.35 0 00-6.432-.535c-5.38 2.586-8.038 7.388-9.114 12.854-1.587 8.076 0 15.8 3.994 23.023 3.673 6.633 9.266 11.478 15.128 16.079 5.6 4.4 11.654 8.276 16.368 13.709 6.238 7.2 8.048 15.357 4.668 24.293a21.6 21.6 0 01-13.831 13.495l-.2 4.818a1.922 1.922 0 01-2 1.829l-5.161-.211a1.921 1.921 0 01-1.841-1.986l.131-3.172c-1.989-.039-3.984-.258-5.98-.423-.913 1.554-5.426 3.264-11.009 4.058-4.869.695-9.143.494-11.038-.385-1.31.74-2.587 1.544-3.859 2.358q-1.173.755-2.352 1.359l1.264 3.194a1.9 1.9 0 01-.023 1.468 1.924 1.924 0 01-1.063 1.021l-4.808 1.876a1.937 1.937 0 01-2.494-1.078l-1.549-3.91a22.977 22.977 0 01-12.409-2.761c-8.468-4.38-11.585-12.3-10.993-20.155.414-5.491 2.6-10.4 5.56-14.966 3.211-4.955 6.654-9.764 9.84-14.733 4.483-6.991 6.248-14.52 4.315-22.769-1.331-5.689-4.224-10.27-9.308-13.233-3.3-1.927-6.862-3.339-10.86-2.068-2.4.767-3.481 2.306-3.214 4.6.227 1.956 1.751 3.306 4.032 3.555.638.069 1.278.1 2.249.18-.7.627-1.05 1-1.461 1.306a20.029 20.029 0 00-6.5 23.685c1.167 2.74.706 4.824-.834 7.151-5.93 8.972-9.725 18.676-10.56 29.517a63.08 63.08 0 001.339 19.752 52.39 52.39 0 0020.191 30.81c4.62 3.431 9.586 5.775 15.64 5.363a118.553 118.553 0 0112.816-.018c4.769.193 5.916-2.244 6.324-5.955.062-.566-.014-1.146.015-1.717.332-6.461 3.984-11.663 11.547-11.708 5.351-.033 9.21 2.1 10.651 6.5a31.16 31.16 0 011.013 6.562c.424 4.214 1.254 6.478 6.391 6.319 6-.183 12.021.035 18.017-.1a14.436 14.436 0 005.158-1.092c7.168-3.021 12.879-8 17.845-13.806 10.143-11.848 15.132-25.77 15.92-41.168a70.6 70.6 0 00-5.801-32.282zm-58.605-31.515a8.269 8.269 0 01-2.785-.591 1.5 1.5 0 01.963-.884 1.408 1.408 0 011.8.825 1.242 1.242 0 01.022.65zm2.611-.581a7.907 7.907 0 01-1.1.362 2.837 2.837 0 00.609-2.719 3.252 3.252 0 00-6.21 1.732 4.718 4.718 0 01-1.461-1.889c-1.166-2.773.593-6.144 3.93-7.529s6.99-.257 8.159 2.516-.593 6.143-3.927 7.526zm-53.33 19.075a1.418 1.418 0 01-.259.079h-.012a.529.529 0 01-.222-.285.55.55 0 01-.024-.151.6.6 0 01.443-.562.648.648 0 01.421.008.544.544 0 01.336.338v.008a1.381 1.381 0 01-.683.566zm-3.757-6.494c2.322-.939 4.869-.175 5.677 1.707a3.341 3.341 0 01-.265 3.036v-.027c-.015-.045-.03-.088-.047-.131s-.033-.076-.052-.113-.04-.079-.061-.115-.046-.074-.07-.109a2.019 2.019 0 00-1.129-.808 2.421 2.421 0 00-.9-.08l-.056.008a.76.76 0 00-.152.024 2.318 2.318 0 00-.272.068 1.177 1.177 0 00-.152.053.113.113 0 00-.032.011 1.16 1.16 0 00-.116.05.361.361 0 00-.055.026c-.047.023-.094.047-.14.074l-.1.059a2.163 2.163 0 00-.181.128c-.04.03-.079.063-.117.1l-.111.106-.012.012c-.035.038-.07.076-.1.113l-.1.125c-.033.042-.061.088-.088.133s-.055.091-.079.136l-.043.088a.743.743 0 00-.033.08.036.036 0 00-.008.015l-.032.083a2.111 2.111 0 00-.059.207c-.009.045-.018.088-.024.133l-.005.063v.065a1.8 1.8 0 00.075.726 1.864 1.864 0 00.338.618 1.951 1.951 0 00.513.436 4.09 4.09 0 01-4.74-1.992c-.819-1.874.406-4.159 2.728-5.1z"
          fill="#2f2e41"
        />
        <path
          data-name="Path 14"
          d="M1139.905 238.974c0-2.924-5.755-5.291-12.856-5.291s-12.859 2.371-12.859 5.291 5.758 5.291 12.859 5.291 12.856-2.362 12.856-5.291zm-13.6 3.1c-2.243-.048-4.026-.5-3.987-1s1.887-.871 4.127-.822 4.026.5 3.987 1-1.878.872-4.118.821z"
          fill="#2f2e41"
        />
        <path
          data-name="Path 15"
          d="M871.447 802.012a17.04 17.04 0 0113.075 6.182 16.658 16.658 0 013.85 10.743 16.925 16.925 0 11-16.925-16.925z"
          fill="none"
          stroke="#3f3d56"
          strokeWidth={2}
        />
        <ellipse
          data-name="Ellipse 41"
          cx={28.808}
          cy={9.224}
          rx={28.808}
          ry={9.224}
          transform="rotate(-150 562.588 -9.9)"
          fill="#2f2e41"
        />
        <ellipse
          data-name="Ellipse 42"
          cx={21.308}
          cy={6.724}
          rx={21.308}
          ry={6.724}
          transform="rotate(180 550.983 156.784)"
          fill="#2f2e41"
        />
        <ellipse
          data-name="Ellipse 43"
          cx={21.308}
          cy={6.724}
          rx={21.308}
          ry={6.724}
          transform="rotate(180 582.983 156.784)"
          fill="#2f2e41"
        />
        <path
          data-name="Line 4"
          fill="none"
          stroke="#2f2e41"
          d="M1109.5 334.425h43"
        />
        <path
          data-name="Line 5"
          fill="none"
          stroke="#2f2e41"
          d="M1069.5 325.425h89"
        />
      </g>
    </svg>
  )
}

export default SvgComponent
